import React from 'react';
import '../style.scss';

type tncs = {
  title: string;
  number: number;
};

type description = {
  desc: string | React.ReactNode;
  id: string;
};

const bulletItemStyle: React.CSSProperties = { marginTop: '10px' };

export const TNCs: tncs[] = [
  {
    title: 'Term of Conditions',
    number: 1,
  },
  {
    title: 'User Agreement',
    number: 2,
  },
];

export const Description: description[] = [
  {
    id: '1. Acceptance of Terms',
    desc: (
      <div>
        <p>
          By accessing or using the Rossby Office website or services, you agree to be bound by
          these Terms of Service as a User. If you do not agree to these Terms, you may not access
          or use the Rossby Office website or services.
        </p>
      </div>
    ),
  },
  {
    id: '2. Description of Services',
    desc: (
      <div>
        <p>
          Rossby Office provides access to a marketplace of virtual service providers that help
          financial service professionals and businesses manage their work and collaborate
          effectively. These tools may include, but are not limited to, a cloud-based office suite,
          a project management tool, and a communication platform.
        </p>
      </div>
    ),
  },
  {
    id: '3. Definitions',
    desc: (
      <div>
        <ul>
          <li style={bulletItemStyle}>
            <strong>Online Marketplace:</strong> An online marketplace is a platform that allows
            buyers and sellers to connect and transact electronically. Online marketplaces can be
            general, such as Amazon or eBay, or they can be specialized in a particular product or
            service category, such as Etsy or Upwork.
          </li>
          <li style={bulletItemStyle}>
            <strong>Virtual Assistant:</strong> A virtual assistant is a self-employed worker who
            provides administrative, technical, or creative assistance to clients from a remote
            location. Virtual assistants typically use technology such as email, phone, and video
            conferencing to communicate with clients.
          </li>
          <li style={bulletItemStyle}>
            <strong>Virtual Service Provider:</strong> A virtual service provider is a business that
            provides services to clients online. Virtual service providers can offer a wide range of
            services, such as marketing, accounting, and customer service.
          </li>
          <li style={bulletItemStyle}>
            <strong>Financial Advisor:</strong> A financial advisor is a professional who provides
            financial advice to individuals and businesses. Financial advisors can help clients with
            a variety of tasks, such as planning for retirement, investing, and managing debt.
          </li>
          <li style={bulletItemStyle}>
            <strong>Broker-Dealer:</strong> A broker-dealer is a financial intermediary that buys
            and sells securities on behalf of its clients. Broker-dealers can also provide
            investment advice to clients.
          </li>
          <li style={bulletItemStyle}>
            <strong>Registered Investment Advisor (RIA):</strong> An RIA is a financial advisor who
            is registered with the Securities and Exchange Commission (SEC). RIAs are required to
            meet certain fiduciary standards, which means that they must put their clients&apos;
            interests ahead of their own.
          </li>
        </ul>
        <div style={{ marginTop: '15px' }}>
          <p>
            <strong>Additional considerations</strong>
          </p>
          <ul>
            <li>The specific definitions of these terms may vary depending on the jurisdiction.</li>
            <li>
              It is important to consult with a legal professional to understand the specific legal
              requirements that apply to your business.
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  {
    id: '4. User Accounts',
    desc: (
      <p>
        To access certain features of the Rossby Office services, you may be required to create a
        user account. You agree to provide accurate and complete information when creating your user
        account. You are responsible for maintaining the confidentiality of your user account login
        information and for all activity that occurs under your user account. You agree to notify
        Rossby Office immediately of any unauthorized use of your user account.
      </p>
    ),
  },
  {
    id: '5. User Conduct',
    desc: (
      <div>
        <p>
          You agree to use the Rossby Office services in a lawful, responsible, and non-abusive
          manner. You agree not to use the Rossby Office services to:
        </p>
        <ul>
          <li style={bulletItemStyle}>
            Transmit any content that is unlawful, harmful, threatening, abusive, harassing,
            tortious, defamatory, vulgar, obscene, libelous, invasive of another&apos;s privacy,
            hateful, or racially, ethnically, or otherwise objectionable.
          </li>
          <li style={bulletItemStyle}>
            Transmit any content that you do not have the right to transmit under any law, or under
            contractual or fiduciary relationships (such as inside information, proprietary and
            confidential information learned or disclosed as part of employment relationships or
            under nondisclosure agreements).
          </li>
          <li style={bulletItemStyle}>
            Transmit any content that infringes any patent, trademark, copyright, or other
            intellectual property right of any party.
          </li>
          <li style={bulletItemStyle}>
            Transmit any content that contains software viruses, Trojan horses, worms, time bombs,
            cancelbots, or other harmful or disruptive code.
          </li>
          <li style={bulletItemStyle}>
            Interfere with or disrupt the Rossby Office services or servers or networks connected to
            the Rossby Office services.
          </li>
          <li style={bulletItemStyle}>
            Attempt to gain unauthorized access to the Rossby Office services or any part of the
            Rossby Office services.
          </li>
        </ul>
      </div>
    ),
  },
  {
    id: '6. Content Ownership',
    desc: (
      <p>
        You retain all ownership rights to the content that you create and upload to the Rossby
        Office services. However, you grant Rossby Office a non-exclusive, worldwide, royalty-free
        license to use, reproduce, modify, adapt, publish, translate, create derivative works from,
        distribute, and display your content in connection with providing the Rossby Office
        services.
      </p>
    ),
  },
  {
    id: '7. Payment(s)',
    desc: (
      <div>
        <p style={bulletItemStyle}>
          <strong>Advisor Users.</strong> You agree to pay all fees associated with your use of the
          Rossby Office services and will be invoiced based on projects completed or hours worked by
          service providers. Invoice payments are due and payable by the 15th day after each billing
          cycle. If you fail to pay your fees in a timely manner, Rossby Office may add a payment
          penalty. Rossby Office may suspend or terminate your access to the Rossby Office services
          for continual late or non payment of invoices.
        </p>
        <p style={bulletItemStyle}>
          <strong>Service Provider Users.</strong> You agree to utilize the time and project
          tracking tools provided by Rossby Office (this will include but not limited to HARVEST,
          Inc.). All billing for time and projects will be processed by Rossby Office and funds
          received will be remitted to Service Providers with proper banking and tax information on
          file with Rossby Office. You also agree to Rossby Office to withhold between 10% to 30% of
          invoiced and received payment from Advisors that will include but will not be limited to
          marketing, platform maintenance, and overall continuation of business service. Rossby
          Office agrees to remit payment on best efforts based on payment received after invoicing
          from projects and hourly work.
        </p>
        <p style={bulletItemStyle}>
          <strong>Boosted Posts.</strong> For Advisors or Service providers who want to post their
          Job or Service in prominence over other users there will be a fee collected for this
          service. You agree that should you want to boost your posting you will pay the following
          fees, which will be good for two weeks from payment and confirmation of posts:
        </p>
        <table style={{ borderCollapse: 'collapse', marginTop: '10px' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', padding: '4px 12px 4px 0' }}>Boost reach</th>
              <th style={{ textAlign: 'left', padding: '4px 0' }}>Fee</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: '4px 12px 4px 0' }}>National</td>
              <td style={{ padding: '4px 0' }}>$5.00</td>
            </tr>
            <tr>
              <td style={{ padding: '4px 12px 4px 0' }}>Within 100 miles of your location</td>
              <td style={{ padding: '4px 0' }}>$10.00</td>
            </tr>
            <tr>
              <td style={{ padding: '4px 12px 4px 0' }}>Within 50 miles of your location</td>
              <td style={{ padding: '4px 0' }}>$40.00</td>
            </tr>
            <tr>
              <td style={{ padding: '4px 12px 4px 0' }}>Within 20 miles of your location</td>
              <td style={{ padding: '4px 0' }}>$60.00</td>
            </tr>
          </tbody>
        </table>
      </div>
    ),
  },
  {
    id: '8. Late Payment Fees',
    desc: (
      <p>
        If your account is past due, you may be charged a late payment fee of 2% of the unpaid
        balance for each month that your account is past due.
      </p>
    ),
  },
  {
    id: '9. Refunds',
    desc: (
      <p>
        Rossby Office does not offer refunds unless otherwise discussed with management of Rossby
        Office.
      </p>
    ),
  },
  {
    id: '10. Cybersecurity and Breach Notification',
    desc: (
      <p>
        As a condition of this Agreement, Rossby Office and Contractor acknowledge the requirement
        of Contractor to be familiar with, and to abide by, the cybersecurity policy of the firms
        they work with. Contractor shall utilize a cloud-based solution to store and share documents
        with Financial Professional and shall not store Firm documents on the local drive of their
        device(s). The use of multifactor authentication (MFA) when accessing such solution is
        required. In the event of a data compromise or breach, Contractor must provide immediate
        notice to the firm and Rossby Office.
      </p>
    ),
  },
  {
    id: '11. Cyber Insurance',
    desc: (
      <p>
        Advisors and Providers agree to maintain a cyber insurance policy that covers their
        activities independent of any policy of Rossby Office. Costs associated with the policy are
        the responsibility of the provider. The policy must provide a minimum $1M in aggregate
        coverage. A copy of such certificate shall be provided to the Rossby Office at the time of
        profile creation. If an Advisor or Provider does not have a Cyber Insurance Policy they can
        purchase one through our insurance company Rossby Insurance L.L.C. or purchase one in the
        open market.
      </p>
    ),
  },
  {
    id: '12. Indemnification',
    desc: (
      <p>
        You agree to indemnify and hold harmless Rossby Office, its affiliates, officers, employees,
        agents, contractors, and licensors from and against any and all claims, liabilities,
        damages, losses, costs, expenses, and fees (including reasonable attorneys&apos; fees)
        arising out of or in connection with your use of the Rossby Office services or your
        violation of these Terms of Service.
      </p>
    ),
  },
  {
    id: '13. Non-Disclosure',
    desc: (
      <p>
        All users will be required to sign off on the Mutual Non-Disclosure agreement between
        Advisor and Provider with an Rossby Office representative witnessing the signatures. All
        parties will be bound by the agreement per the terms stated within that document.
      </p>
    ),
  },
  {
    id: '14. Disclaimer of Warranties',
    desc: (
      <p>
        THE ROSSBY OFFICE SERVICES ARE PROVIDED ON AN &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot;
        BASIS. Rossby Office MAKES NO WARRANTIES, EXPRESS OR IMPLIED, ABOUT THE ROSSBY OFFICE
        SERVICES, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR
        A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT. ROSSBY OFFICE DOES NOT WARRANT THAT THE
        Rossby Office SERVICES WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.
      </p>
    ),
  },
  {
    id: '15. Limitation of Liability',
    desc: (
      <p>
        IN NO EVENT SHALL ROSSBY OFFICE, ITS AFFILIATES, OFFICERS, EMPLOYEES, AGENTS, CONTRACTORS,
        OR LICENSORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR
        EXEMPLARY DAMAGES ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE Rossby Office
        SERVICES, EVEN IF Rossby Office HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
      </p>
    ),
  },
  {
    id: '16. Termination',
    desc: (
      <p>
        Rossby Office may terminate your access to the Rossby Office services at any time, without
        notice or reason. Upon termination, you shall immediately cease all use of the Rossby Office
        services.
      </p>
    ),
  },
  {
    id: '17. General Provisions',
    desc: (
      <p>
        These Terms of Service constitute the entire agreement between you and Rossby Office with
        respect to the Rossby Office services and supersede all prior or contemporaneous
        communications, representations, or agreements, whether oral or written. If any provision of
        these Terms of Service is held to be invalid or unenforceable, such provision shall be
        struck from these Terms of Service and the remaining provisions shall remain in full force
        and effect. These Terms of Service shall be governed by and construed in accordance with the
        laws of the State of Florida, without regard to its conflict of laws principles. Any dispute
        arising out of or relating to these Terms of Service shall be resolved exclusively in the
        courts of the State of Florida.
      </p>
    ),
  },
];
export const UserAggrement: description[] = [
  {
    id: '1. Demo',
    desc: (
      <div>
        <p>
          By accessing or using the Rossby Office website or services, you agree to be bound by
          these Terms of Service as a User. If you do not agree to these Terms, you may not access
          or use the Rossby Office website or services.
        </p>
      </div>
    ),
  },
  {
    id: '2. Demo',
    desc: (
      <div>
        <p>
          Rossby Office provides access to a marketplace of virtual service providers that help
          financial service professionals and businesses manage their work and collaborate
          effectively. These tools may include, but are not limited to, a cloud-based office suite,
          a project management tool, and a communication platform.
        </p>
      </div>
    ),
  },
  {
    id: '3. Demo',
    desc: (
      <div>
        <p>
          By accessing or using the Rossby Office website or services, you agree to be bound by
          these Terms of Service as a User. If you do not agree to these Terms, you may not access
          or use the Rossby Office website or services.
        </p>
      </div>
    ),
  },
  {
    id: '4. Demo',
    desc: (
      <div>
        <p>
          Rossby Office provides access to a marketplace of virtual service providers that help
          financial service professionals and businesses manage their work and collaborate
          effectively. These tools may include, but are not limited to, a cloud-based office suite,
          a project management tool, and a communication platform.
        </p>
      </div>
    ),
  },
];

// Map of ToS version -> description sections. Versions are append-only;
// add a new entry alongside a backend migration that inserts the matching
// row in `tos_versions` and bump `CURRENT_TOS_VERSION` in
// `src/utils/config.tsx`.
export const tosVersions: Record<string, description[]> = {
  '2026-05-11': Description,
};
